export const countrySlugMap: Record<string, Record<string, string>> = {
  RO: {
    af: "roemenie",
    ar: "رومانيا",
    bg: "румъния",
    cs: "rumunsko",
    da: "rumanien",
    de: "rumanien",
    el: "roumania",
    en: "romania",
    es: "rumania",
    et: "rumeenia",
    fi: "romania",
    fr: "roumanie",
    he: "רומניה",
    hi: "romaniya",
    hr: "rumunija",
    hu: "romania",
    id: "romania",
    it: "romania",
    ja: "ルーマニア",
    ko: "루마니아",
    lt: "rumunija",
    lv: "rumunija",
    ms: "romania",
    nl: "roemenie",
    no: "romania",
    pl: "rumunia",
    pt: "romenia",
    ro: "romania",
    ru: "румыния",
    sk: "rumunsko",
    sl: "romunija",
    sr: "rumunija",
    sv: "rumanien",
    sw: "romania",
    th: "โรมาเนีย",
    tl: "romanya",
    tr: "romanya",
    uk: "румунія",
    vi: "romania",
    zh: "罗马尼亚",
  },
  PT: {
    af: "portugal",
    ar: "البرتغال",
    bg: "португалия",
    cs: "portugalsko",
    da: "portugal",
    de: "portugal",
    el: "portogalia",
    en: "portugal",
    es: "portugal",
    et: "portugal",
    fi: "portugali",
    fr: "portugal",
    he: "פורטוגל",
    hi: "portugal",
    hr: "portugal",
    hu: "portugalia",
    id: "portugal",
    it: "portogallo",
    ja: "ポルトガル",
    ko: "포르투갈",
    lt: "portugalija",
    lv: "portugale",
    ms: "portugal",
    nl: "portugal",
    no: "portugal",
    pl: "portugalia",
    pt: "portugal",
    ro: "portugalia",
    ru: "португалия",
    sk: "portugalsko",
    sl: "portugalska",
    sr: "portugal",
    sv: "portugal",
    sw: "portugal",
    th: "โปรตุเกส",
    tl: "portugal",
    tr: "portekiz",
    uk: "португалія",
    vi: "bodao-nha",
    zh: "葡萄牙",
  },
  ES: {
    af: "spanje",
    ar: "اسبانيا",
    bg: "испания",
    cs: "spanelsko",
    da: "spanien",
    de: "spanien",
    el: "spania",
    en: "spain",
    es: "espana",
    et: "hispaania",
    fi: "espanja",
    fr: "espagne",
    he: "ספרד",
    hi: "spen",
    hr: "spanjolska",
    hu: "spanyolorszag",
    id: "spanyol",
    it: "spagna",
    ja: "スペイン",
    ko: "스페인",
    lt: "ispanija",
    lv: "spanija",
    ms: "sepanyol",
    nl: "spanje",
    no: "spania",
    pl: "hiszpania",
    pt: "espanha",
    ro: "spania",
    ru: "испания",
    sk: "spanielsko",
    sl: "spanija",
    sr: "spanija",
    sv: "spanien",
    sw: "hispania",
    th: "สเปน",
    tl: "espanya",
    tr: "ispanya",
    uk: "іспанія",
    vi: "taybannha",
    zh: "西班牙",
  },
  GB: {
    af: "verenigde-koninkryk",
    ar: "المملكة-المتحدة",
    bg: "великобритания",
    cs: "spojene-kralovstvi",
    da: "storbritannien",
    de: "vereinigtes-konigreich",
    el: "inomeno-vasileio",
    en: "united-kingdom",
    es: "reino-unido",
    et: "uhendkuningriik",
    fi: "yhdistynyt-kuningaskunta",
    fr: "royaume-uni",
    he: "הממלכה-המאוחדת",
    hi: "united-kingdom",
    hr: "ujedinjeno-kraljevstvo",
    hu: "egyesult-kiralysag",
    id: "inggris-raya",
    it: "regno-unito",
    ja: "イギリス",
    ko: "영국",
    lt: "jungtine-karalyste",
    lv: "apvienota-karaliste",
    ms: "united-kingdom",
    nl: "verenigd-koninkrijk",
    no: "storbritannia",
    pl: "wielka-brytania",
    pt: "reino-unido",
    ro: "regatul-unit",
    ru: "великобритания",
    sk: "spojene-kralovstvo",
    sl: "zdruzeno-kraljestvo",
    sr: "ujedinjeno-kraljevstvo",
    sv: "storbritannien",
    sw: "ufalme-wa-muungano",
    th: "สหราชอาณาจักร",
    tl: "nakapisan-na-kaharian",
    tr: "birlesik-krallik",
    uk: "велика-британія",
    vi: "vuong-quoc-anh",
    zh: "英国",
  },
  BE: {
    af: "belgie",
    ar: "بلجيكا",
    bg: "белгия",
    cs: "belgie",
    da: "belgien",
    de: "belgien",
    el: "velgio",
    en: "belgium",
    es: "belgica",
    et: "belgia",
    fi: "belgia",
    fr: "belgique",
    he: "בלגיה",
    hi: "belgium",
    hr: "belgija",
    hu: "belgium",
    id: "belgia",
    it: "belgio",
    ja: "ベルギー",
    ko: "벨기에",
    lt: "belgija",
    lv: "belgija",
    ms: "belgium",
    nl: "belgie",
    no: "belgia",
    pl: "belgia",
    pt: "belgica",
    ro: "belgia",
    ru: "бельгия",
    sk: "belgicko",
    sl: "belgija",
    sr: "belgija",
    sv: "belgien",
    sw: "belgium",
    th: "เบลเยียม",
    tl: "belhika",
    tr: "belcika",
    uk: "бельгія",
    vi: "bi",
    zh: "比利时",
  },
  NL: {
    af: "nederland",
    ar: "هولندا",
    bg: "нидерландия",
    cs: "nizozemi",
    da: "holland",
    de: "niederlande",
    el: "kato-hores",
    en: "netherlands",
    es: "paises-bajos",
    et: "holland",
    fi: "alankomaat",
    fr: "pays-bas",
    he: "הולנד",
    hi: "netherlands",
    hr: "nizozemska",
    hu: "hollandia",
    id: "belanda",
    it: "paesi-bassi",
    ja: "オランダ",
    ko: "네덜란드",
    lt: "olandija",
    lv: "niderlande",
    ms: "belanda",
    nl: "nederland",
    no: "nederland",
    pl: "holandia",
    pt: "paises-baixos",
    ro: "olanda",
    ru: "нидерланды",
    sk: "nizozemsko",
    sl: "nizozemska",
    sr: "holandija",
    sv: "nederländerna",
    sw: "uholanzi",
    th: "เนเธอร์แลนด์",
    tl: "olanda",
    tr: "hollanda",
    uk: "нідерланди",
    vi: "ha-lan",
    zh: "荷兰",
  },
  CH: {
    af: "switserland",
    ar: "سويسرا",
    bg: "швейцария",
    cs: "svycarsko",
    da: "schweiz",
    de: "schweiz",
    el: "svisa",
    en: "switzerland",
    es: "suiza",
    et: "sveits",
    fi: "sveitsi",
    fr: "suisse",
    he: "שווייץ",
    hi: "switzerland",
    hr: "svicarska",
    hu: "svejc",
    id: "swiss",
    it: "svizzera",
    ja: "スイス",
    ko: "스위스",
    lt: "sveicarija",
    lv: "sveice",
    ms: "switzerland",
    nl: "zwitserland",
    no: "sveits",
    pl: "szwajcaria",
    pt: "suica",
    ro: "elvetia",
    ru: "швейцария",
    sk: "svajciarsko",
    sl: "svica",
    sr: "svajcarska",
    sv: "schweiz",
    sw: "uswisi",
    th: "สวิตเซอร์แลนด์",
    tl: "switzerland",
    tr: "isvicre",
    uk: "швейцарія",
    vi: "thuy-si",
    zh: "瑞士",
  },
  IT: {
    af: "italie",
    ar: "ايطاليا",
    bg: "италия",
    cs: "italie",
    da: "italien",
    de: "italien",
    el: "italia",
    en: "italy",
    es: "italia",
    et: "itaalia",
    fi: "italia",
    fr: "italie",
    he: "איטליה",
    hi: "italy",
    hr: "italija",
    hu: "olaszorszag",
    id: "italia",
    it: "italia",
    ja: "イタリア",
    ko: "이탈리아",
    lt: "italija",
    lv: "italija",
    ms: "italy",
    nl: "italie",
    no: "italia",
    pl: "wlochy",
    pt: "italia",
    ro: "italia",
    ru: "италия",
    sk: "taliansko",
    sl: "italija",
    sr: "italija",
    sv: "italien",
    sw: "italia",
    th: "อิตาลี",
    tl: "italya",
    tr: "italya",
    uk: "італія",
    vi: "nuoc-y",
    zh: "意大利",
  },
  AT: {
    af: "oostenryk",
    ar: "النمسا",
    bg: "австрия",
    cs: "rakousko",
    da: "oesterrig",
    de: "osterreich",
    el: "austria",
    en: "austria",
    es: "austria",
    et: "austria",
    fi: "itävalta",
    fr: "autriche",
    he: "אוסטריה",
    hi: "austria",
    hr: "austrija",
    hu: "ausztria",
    id: "austria",
    it: "austria",
    ja: "オーストリア",
    ko: "오스트리아",
    lt: "austrija",
    lv: "austrija",
    ms: "austria",
    nl: "oostenrijk",
    no: "osterrike",
    pl: "austria",
    pt: "austria",
    ro: "austria",
    ru: "австрия",
    sk: "rakusko",
    sl: "avstrija",
    sr: "austrija",
    sv: "osterrike",
    sw: "austria",
    th: "ออสเตรีย",
    tl: "austria",
    tr: "avusturya",
    uk: "австрія",
    vi: "ao",
    zh: "奥地利",
  },
  PL: {
    af: "pole",
    ar: "بولندا",
    bg: "полша",
    cs: "polsko",
    da: "polen",
    de: "polen",
    el: "polonia",
    en: "poland",
    es: "polonia",
    et: "poola",
    fi: "puola",
    fr: "pologne",
    he: "פולין",
    hi: "poland",
    hr: "poljska",
    hu: "lengyelorszag",
    id: "polandia",
    it: "polonia",
    ja: "ポーランド",
    ko: "폴란드",
    lt: "lenkija",
    lv: "polija",
    ms: "poland",
    nl: "polen",
    no: "polen",
    pl: "polska",
    pt: "polonia",
    ro: "polonia",
    ru: "польша",
    sk: "polsko",
    sl: "poljska",
    sr: "poljska",
    sv: "polen",
    sw: "poland",
    th: "โปแลนด์",
    tl: "polonya",
    tr: "polonya",
    uk: "польща",
    vi: "ba-lan",
    zh: "波兰",
  },
  HU: {
    af: "hongarye",
    ar: "المجر",
    bg: "унгария",
    cs: "madarsko",
    da: "ungarn",
    de: "ungarn",
    el: "ougaria",
    en: "hungary",
    es: "hungria",
    et: "ungari",
    fi: "unkari",
    fr: "hongrie",
    he: "הונגריה",
    hi: "hungary",
    hr: "madarska",
    hu: "magyarorszag",
    id: "hungaria",
    it: "ungheria",
    ja: "ハンガリー",
    ko: "헝가리",
    lt: "vengrija",
    lv: "ungarija",
    ms: "hungary",
    nl: "hongarije",
    no: "ungarn",
    pl: "wegry",
    pt: "hungria",
    ro: "ungaria",
    ru: "венгрия",
    sk: "madarsko",
    sl: "madzarska",
    sr: "madjarska",
    sv: "ungern",
    sw: "hungaria",
    th: "ฮังการี",
    tl: "hungary",
    tr: "macaristan",
    uk: "угорщина",
    vi: "hung-ga-ri",
    zh: "匈牙利",
  },
  RS: {
    af: "serwie",
    ar: "صربيا",
    bg: "сърбия",
    cs: "srbsko",
    da: "serbien",
    de: "serbien",
    el: "servia",
    en: "serbia",
    es: "serbia",
    et: "serbia",
    fi: "serbia",
    fr: "serbie",
    he: "סרביה",
    hi: "serbia",
    hr: "srbija",
    hu: "szerbia",
    id: "serbia",
    it: "serbia",
    ja: "セルビア",
    ko: "세르비아",
    lt: "serbija",
    lv: "serbija",
    ms: "serbia",
    nl: "servie",
    no: "serbia",
    pl: "serbia",
    pt: "servia",
    ro: "serbia",
    ru: "сербия",
    sk: "srbsko",
    sl: "srbija",
    sr: "srbija",
    sv: "serbien",
    sw: "serbia",
    th: "เซอร์เบีย",
    tl: "serbia",
    tr: "sirbistan",
    uk: "сербія",
    vi: "serbia",
    zh: "塞尔维亚",
  },
  HR: {
    af: "kroasie",
    ar: "كرواتيا",
    bg: "хърватия",
    cs: "chorvatsko",
    da: "kroatien",
    de: "kroatien",
    el: "kroatia",
    en: "croatia",
    es: "croacia",
    et: "horvaatia",
    fi: "kroatia",
    fr: "croatie",
    he: "קרואטיה",
    hi: "croatia",
    hr: "hrvatska",
    hu: "horvatorszag",
    id: "kroasia",
    it: "croazia",
    ja: "クロアチア",
    ko: "크로아티아",
    lt: "kroatija",
    lv: "horvatija",
    ms: "croatia",
    nl: "kroatie",
    no: "kroatia",
    pl: "chorwacja",
    pt: "croacia",
    ro: "croatia",
    ru: "хорватия",
    sk: "chorvatsko",
    sl: "hrvaska",
    sr: "hrvatska",
    sv: "kroatien",
    sw: "croatia",
    th: "โครเอเชีย",
    tl: "croatia",
    tr: "hirvatistan",
    uk: "хорватія",
    vi: "croatia",
    zh: "克罗地亚",
  },
  BG: {
    af: "bulgarie",
    ar: "بلغاريا",
    bg: "българия",
    cs: "bulharsko",
    da: "bulgarien",
    de: "bulgarien",
    el: "voulgaria",
    en: "bulgaria",
    es: "bulgaria",
    et: "bulgaaria",
    fi: "bulgaria",
    fr: "bulgarie",
    he: "בולגריה",
    hi: "bulgaria",
    hr: "bugarska",
    hu: "bulgaria",
    id: "bulgaria",
    it: "bulgaria",
    ja: "ブルガリア",
    ko: "불가리아",
    lt: "bulgarija",
    lv: "bulgarija",
    ms: "bulgaria",
    nl: "bulgarije",
    no: "bulgaria",
    pl: "bułgaria",
    pt: "bulgaria",
    ro: "bulgaria",
    ru: "болгария",
    sk: "bulharsko",
    sl: "bolgarija",
    sr: "bugarska",
    sv: "bulgarien",
    sw: "bulgaria",
    th: "บัลแกเรีย",
    tl: "bulgaria",
    tr: "bulgaristan",
    uk: "болгарія",
    vi: "bulgaria",
    zh: "保加利亚",
  },
  NO: {
    af: "noorwee",
    ar: "النرويج",
    bg: "норвегия",
    cs: "norsko",
    da: "norge",
    de: "norwegen",
    el: "norvigia",
    en: "norway",
    es: "noruega",
    et: "norra",
    fi: "norja",
    fr: "norvege",
    he: "נורווגיה",
    hi: "norway",
    hr: "norveska",
    hu: "norvegia",
    id: "norwegia",
    it: "norvegia",
    ja: "ノルウェー",
    ko: "노르웨이",
    lt: "norvegija",
    lv: "norvegija",
    ms: "norway",
    nl: "noorwegen",
    no: "norge",
    pl: "norwegia",
    pt: "noruega",
    ro: "norvegia",
    ru: "норвегия",
    sk: "norsko",
    sl: "norveska",
    sr: "norveska",
    sv: "norge",
    sw: "norway",
    th: "นอร์เวย์",
    tl: "norway",
    tr: "norvec",
    uk: "норвегія",
    vi: "na-uy",
    zh: "挪威",
  },
  SE: {
    af: "swede",
    ar: "السويد",
    bg: "швеция",
    cs: "svedsko",
    da: "sverige",
    de: "schweden",
    el: "souidia",
    en: "sweden",
    es: "suecia",
    et: "rootsi",
    fi: "ruotsi",
    fr: "suede",
    he: "שוודיה",
    hi: "sweden",
    hr: "svedska",
    hu: "svedorszag",
    id: "swedia",
    it: "svezia",
    ja: "スウェーデン",
    ko: "스웨덴",
    lt: "svedija",
    lv: "zviedrija",
    ms: "sweden",
    nl: "zweden",
    no: "sverige",
    pl: "szwecja",
    pt: "suecia",
    ro: "suedia",
    ru: "швеция",
    sk: "svedsko",
    sl: "svedska",
    sr: "svedska",
    sv: "sverige",
    sw: "sweden",
    th: "สวีเดน",
    tl: "sweden",
    tr: "isvec",
    uk: "швеція",
    vi: "thuy-dien",
    zh: "瑞典",
  },
  FI: {
    af: "finland",
    ar: "فنلندا",
    bg: "финландия",
    cs: "finsko",
    da: "finland",
    de: "finnland",
    el: "finlandia",
    en: "finland",
    es: "finlandia",
    et: "soome",
    fi: "suomi",
    fr: "finlande",
    he: "פינלנד",
    hi: "finland",
    hr: "finska",
    hu: "finnorszag",
    id: "finlandia",
    it: "finlandia",
    ja: "フィンランド",
    ko: "핀란드",
    lt: "suomija",
    lv: "somija",
    ms: "finland",
    nl: "finland",
    no: "finland",
    pl: "finlandia",
    pt: "finlandia",
    ro: "finlanda",
    ru: "финляндия",
    sk: "finsko",
    sl: "finska",
    sr: "finska",
    sv: "finland",
    sw: "finland",
    th: "ฟินแลนด์",
    tl: "finland",
    tr: "finlandiya",
    uk: "фінляндія",
    vi: "phan-lan",
    zh: "芬兰",
  },
  DK: {
    af: "denemarke",
    ar: "الدانمارك",
    bg: "дания",
    cs: "dansko",
    da: "danmark",
    de: "daenemark",
    el: "danmark",
    en: "denmark",
    es: "dinamarca",
    et: "taani",
    fi: "tanska",
    fr: "danemark",
    he: "דנמרק",
    hi: "denmark",
    hr: "danska",
    hu: "dania",
    id: "denmark",
    it: "danimarca",
    ja: "デンマーク",
    ko: "덴마크",
    lt: "danija",
    lv: "dānija",
    ms: "denmark",
    nl: "denemarken",
    no: "danmark",
    pl: "dania",
    pt: "dinamarca",
    ro: "danemarca",
    ru: "дания",
    sk: "dansko",
    sl: "danska",
    sr: "danska",
    sv: "danmark",
    sw: "denmark",
    th: "เดนมาร์ก",
    tl: "denmark",
    tr: "danimarka",
    uk: "данія",
    vi: "dan-mach",
    zh: "丹麦",
  },
  GR: {
    af: "griekeland",
    ar: "اليونان",
    bg: "гърция",
    cs: "recko",
    da: "graekenland",
    de: "griechenland",
    el: "ellada",
    en: "greece",
    es: "grecia",
    et: "kreeka",
    fi: "kreikka",
    fr: "grece",
    he: "יוון",
    hi: "greece",
    hr: "grcka",
    hu: "gorogorszag",
    id: "yunani",
    it: "grecia",
    ja: "ギリシャ",
    ko: "그리스",
    lt: "graikija",
    lv: "griekija",
    ms: "yunani",
    nl: "griekenland",
    no: "hellas",
    pl: "grecja",
    pt: "grecia",
    ro: "grecia",
    ru: "греция",
    sk: "grecko",
    sl: "grcija",
    sr: "grcka",
    sv: "grekland",
    sw: "ugiriki",
    th: "กรีซ",
    tl: "greece",
    tr: "yunanistan",
    uk: "греція",
    vi: "hy-lap",
    zh: "希腊",
  },
  TR: {
    af: "turkye",
    ar: "تركيا",
    bg: "турция",
    cs: "turecko",
    da: "tyrkiet",
    de: "tuerkei",
    el: "tourkia",
    en: "turkiye",
    es: "turquia",
    et: "türgi",
    fi: "turkki",
    fr: "turquie",
    he: "טורקיה",
    hi: "turkiye",
    hr: "turska",
    hu: "torokorszag",
    id: "turki",
    it: "turchia",
    ja: "トルコ",
    ko: "터키",
    lt: "turkija",
    lv: "turcija",
    ms: "turki",
    nl: "turkije",
    no: "tyrkia",
    pl: "turcja",
    pt: "turquia",
    ro: "turcia",
    ru: "турция",
    sk: "turecko",
    sl: "turcija",
    sr: "turska",
    sv: "turkiet",
    sw: "turkia",
    th: "ตุรกี",
    tl: "turkiye",
    tr: "turkiye",
    uk: "туреччина",
    vi: "tho-nhi-ky",
    zh: "土耳其",
  },
  CY: {
    af: "siprus",
    ar: "قبرص",
    bg: "кипър",
    cs: "kypr",
    da: "cypern",
    de: "zypern",
    el: "kypros",
    en: "cyprus",
    es: "chipre",
    et: "kuberna",
    fi: "kypros",
    fr: "chypre",
    he: "קפריסין",
    hi: "cyprus",
    hr: "cipar",
    hu: "ciprus",
    id: "siprus",
    it: "cipro",
    ja: "キプロス",
    ko: "키프로스",
    lt: "kipras",
    lv: "kipra",
    ms: "cyprus",
    nl: "cyprus",
    no: "kypros",
    pl: "cypr",
    pt: "chipre",
    ro: "cipru",
    ru: "кипр",
    sk: "cyprus",
    sl: "cipar",
    sr: "kipar",
    sv: "cypern",
    sw: "cyprus",
    th: "ไซปรัส",
    tl: "cyprus",
    tr: "kibris",
    uk: "кіпр",
    vi: "dao-sip",
    zh: "塞浦路斯",
  },
  CZ: {
    af: "tsjeggie",
    ar: "التشيك",
    bg: "чехия",
    cs: "cesko",
    da: "tjekkiet",
    de: "tschechien",
    el: "tschia",
    en: "czechia",
    es: "chequia",
    et: "tšehhi",
    fi: "tsekki",
    fr: "tchequie",
    he: "צ׳כיה",
    hi: "czechia",
    hr: "ceska",
    hu: "csehorszag",
    id: "ceko",
    it: "cechia",
    ja: "チェコ",
    ko: "체코",
    lt: "cekija",
    lv: "cekija",
    ms: "czechia",
    nl: "tsjechie",
    no: "tsjekkia",
    pl: "czechy",
    pt: "chequia",
    ro: "cehia",
    ru: "чехия",
    sk: "cesko",
    sl: "ceska",
    sr: "ceska",
    sv: "tjeckien",
    sw: "czechia",
    th: "เช็ก",
    tl: "czechia",
    tr: "cekya",
    uk: "чехія",
    vi: "sec",
    zh: "捷克",
  },
  SK: {
    af: "slowakye",
    ar: "سلوفاكيا",
    bg: "словакия",
    cs: "slovensko",
    da: "slovakiet",
    de: "slowakei",
    el: "slovakia",
    en: "slovakia",
    es: "eslovaquia",
    et: "slovakkia",
    fi: "slovakia",
    fr: "slovaquie",
    he: "סלובקיה",
    hi: "slovakia",
    hr: "slovacka",
    hu: "szlovakia",
    id: "slovakia",
    it: "slovacchia",
    ja: "スロバキア",
    ko: "슬로바키아",
    lt: "slovakija",
    lv: "slovakija",
    ms: "slovakia",
    nl: "slowakije",
    no: "slovakia",
    pl: "slowacja",
    pt: "eslovaquia",
    ro: "slovacia",
    ru: "словакия",
    sk: "slovensko",
    sl: "slovaška",
    sr: "slovacka",
    sv: "slovakien",
    sw: "slovakia",
    th: "สโลวาเกีย",
    tl: "slovakia",
    tr: "slovakya",
    uk: "словаччина",
    vi: "slovakia",
    zh: "斯洛伐克",
  },
  SI: {
    af: "sloweenie",
    ar: "سلوفينيا",
    bg: "словения",
    cs: "slovinsko",
    da: "slovenien",
    de: "slowenien",
    el: "slovenia",
    en: "slovenia",
    es: "eslovenia",
    et: "sloveenia",
    fi: "slovenia",
    fr: "slovenie",
    he: "סלובניה",
    hi: "slovenia",
    hr: "slovenija",
    hu: "szlovenia",
    id: "slovenia",
    it: "slovenia",
    ja: "スロベニア",
    ko: "슬로베니아",
    lt: "slovenija",
    lv: "slovenija",
    ms: "slovenia",
    nl: "slovenie",
    no: "slovenia",
    pl: "slowenia",
    pt: "eslovenia",
    ro: "slovenia",
    ru: "словения",
    sk: "slovinsko",
    sl: "slovenija",
    sr: "slovenija",
    sv: "slovenien",
    sw: "slovenia",
    th: "สโลวีเนีย",
    tl: "slovenia",
    tr: "slovenya",
    uk: "словенія",
    vi: "slovenia",
    zh: "斯洛文尼亚",
  },
  AE: {
    af: "verenigde-arabiese-emirate",
    ar: "الامارات-العربية-المتحدة",
    bg: "обединени-арабски-емирства",
    cs: "spojene-arabske-emiraty",
    da: "forenede-arabiske-emirater",
    de: "vereinigte-arabische-emirate",
    el: "enomena-aravika-emirata",
    en: "united-arab-emirates",
    es: "emiratos-arabes-unidos",
    et: "uhendemiraadid",
    fi: "yhdistyneet-arabiemiirikunnat",
    fr: "emirats-arabes-unis",
    he: "איחוד-האמירויות-הערביות",
    hi: "united-arab-emirates",
    hr: "ujedinjeni-arapski-emirati",
    hu: "egyesult-arab-emirsegek",
    id: "uni-emirat-arab",
    it: "emirati-arabi-uniti",
    ja: "アラブ首長国連邦",
    ko: "아랍에미리트",
    lt: "jungtiniai-arabu-emyratai",
    lv: "apvienotie-arabu-emirati",
    ms: "emiriah-arab-bersatu",
    nl: "verenigde-arabische-emiraten",
    no: "forente-arabiske-emirater",
    pl: "zjednoczone-emiraty-arabskie",
    pt: "emirados-arabes-unidos",
    ro: "emiratele-arabe-unite",
    ru: "оаэ",
    sk: "spojene-arabske-emiraty",
    sl: "zdruzeni-arabski-emirati",
    sr: "ujedinjeni-arapski-emirati",
    sv: "förenade-arabemiraten",
    sw: "umoja-wa-falme-za-kiajemi",
    th: "สหรัฐอาหรับเอมิเรตส์",
    tl: "united-arab-emirates",
    tr: "birlesik-arap-emirlikleri",
    uk: "оае",
    vi: "cua-tieu-vuong-quoc-arap-thong-nhat",
    zh: "阿联酋",
  },
  SA: {
    af: "saoedi-arabie",
    ar: "السعودية",
    bg: "саудитска-арабия",
    cs: "saudska-arabie",
    da: "saudi-arabien",
    de: "saudi-arabien",
    el: "saoudiki-aravia",
    en: "saudi-arabia",
    es: "arabia-saudita",
    et: "saudi-araabia",
    fi: "saudi-arabia",
    fr: "arabie-saoudite",
    he: "ערב-הסעודית",
    hi: "saudi-arabia",
    hr: "saudijska-arabija",
    hu: "szaud-arabia",
    id: "arab-saudi",
    it: "arabia-saudita",
    ja: "サウジアラビア",
    ko: "사우디아라비아",
    lt: "saudo-arabija",
    lv: "saudita-arabija",
    ms: "arab-saudi",
    nl: "saudi-arabie",
    no: "saudi-arabia",
    pl: "arabia-saudyjska",
    pt: "arabia-saudita",
    ro: "arabia-saudita",
    ru: "саудовская-аравия",
    sk: "saudska-arabia",
    sl: "saudska-arabija",
    sr: "saudijska-arabija",
    sv: "saudiarabien",
    sw: "saudi-arabia",
    th: "ซาอุดีอาระเบีย",
    tl: "saudi-arabia",
    tr: "suudi-arabistan",
    uk: "саудівська-аравія",
    vi: "a-rap-xu-dau",
    zh: "沙特阿拉伯",
  },
  QA: {
    af: "qatar",
    ar: "قطر",
    bg: "катар",
    cs: "katar",
    da: "qatar",
    de: "katar",
    el: "qatar",
    en: "qatar",
    es: "qatar",
    et: "katar",
    fi: "qatar",
    fr: "qatar",
    he: "קטאר",
    hi: "qatar",
    hr: "katar",
    hu: "katar",
    id: "qatar",
    it: "qatar",
    ja: "カタール",
    ko: "카타르",
    lt: "kataras",
    lv: "katara",
    ms: "qatar",
    nl: "qatar",
    no: "qatar",
    pl: "katar",
    pt: "qatar",
    ro: "qatar",
    ru: "катар",
    sk: "katar",
    sl: "katar",
    sr: "katar",
    sv: "qatar",
    sw: "qatar",
    th: "กาตาร์",
    tl: "qatar",
    tr: "katar",
    uk: "катар",
    vi: "qatar",
    zh: "卡塔尔",
  },
  BH: {
    af: "bahrein",
    ar: "البحرين",
    bg: "бахрейн",
    cs: "bahrajn",
    da: "bahrain",
    de: "bahrain",
    el: "bahrain",
    en: "bahrain",
    es: "barein",
    et: "bahrein",
    fi: "bahrain",
    fr: "bahrein",
    he: "בחריין",
    hi: "bahrain",
    hr: "bahrein",
    hu: "bahrein",
    id: "bahrain",
    it: "bahrein",
    ja: "バーレーン",
    ko: "바레인",
    lt: "bahreinas",
    lv: "bahreina",
    ms: "bahrain",
    nl: "bahrein",
    no: "bahrain",
    pl: "bahrajn",
    pt: "barein",
    ro: "bahrein",
    ru: "бахрейн",
    sk: "bahrajn",
    sl: "bahrajn",
    sr: "bahrein",
    sv: "bahrain",
    sw: "bahrain",
    th: "บาห์เรน",
    tl: "bahrain",
    tr: "bahreyn",
    uk: "бахрейн",
    vi: "ba-ranh",
    zh: "巴林",
  },
  DE: {
    af: "duitsland",
    ar: "ألمانيا",
    bg: "германия",
    cs: "nemecko",
    da: "tyskland",
    de: "deutschland",
    el: "germania",
    en: "germany",
    es: "alemania",
    et: "saksamaa",
    fi: "saksa",
    fr: "allemagne",
    he: "גרמניה",
    hi: "germany",
    hr: "njemacka",
    hu: "nemetorszag",
    id: "jerman",
    it: "germania",
    ja: "ドイツ",
    ko: "독일",
    lt: "vokietija",
    lv: "vacija",
    ms: "jerman",
    nl: "duitsland",
    no: "tyskland",
    pl: "niemcy",
    pt: "alemanha",
    ro: "germania",
    ru: "германия",
    sk: "nemecko",
    sl: "nemcija",
    sr: "njemacka",
    sv: "tyskland",
    sw: "ujerumani",
    th: "เยอรมนี",
    tl: "germany",
    tr: "almanya",
    uk: "німеччина",
    vi: "duc",
    zh: "德国",
  },
  FR: {
    af: "frankryk",
    ar: "فرنسا",
    bg: "франция",
    cs: "francie",
    da: "frankrig",
    de: "frankreich",
    el: "gallia",
    en: "france",
    es: "francia",
    et: "prantsusmaa",
    fi: "ranska",
    fr: "france",
    he: "צרפת",
    hi: "france",
    hr: "francuska",
    hu: "franciaorszag",
    id: "prancis",
    it: "francia",
    ja: "フランス",
    ko: "프랑스",
    lt: "prancuzija",
    lv: "francija",
    ms: "perancis",
    nl: "frankrijk",
    no: "frankrike",
    pl: "francja",
    pt: "franca",
    ro: "franta",
    ru: "франция",
    sk: "francuzsko",
    sl: "francija",
    sr: "francuska",
    sv: "frankrike",
    sw: "ufaransa",
    th: "ฝรั่งเศส",
    tl: "france",
    tr: "fransa",
    uk: "франція",
    vi: "phap",
    zh: "法国",
  },
};

export const countrySlugReverseMap: Record<
  string,
  Record<string, string>
> = Object.entries(countrySlugMap).reduce(
  (acc, [countryCode, locales]) => {
    Object.entries(locales).forEach(([locale, slug]) => {
      if (!acc[locale]) acc[locale] = {};
      acc[locale][slug] = countryCode;
    });
    return acc;
  },
  {} as Record<string, Record<string, string>>,
);

//portugalia
//spania
//uk
//franta
//belgia
//olanda
//germania
//elvetia
//italia
//austria
//polonia
//romania
//ungaria
//serbia
//croatia
//bulgaria
//norvegia
//suedia
//finlanda
//danemarca
//grecia
//turcia
//cipru
//cehia
//slovacia
//slovenia

//uae
//qatar
//saudi arabia
//bahrain
